import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

interface OverflowMarqueeProps {
  text: string
  className?: string
}

export function OverflowMarquee({ text, className }: OverflowMarqueeProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const container = containerRef.current
    const content = textRef.current
    if (!container || !content) return

    const measure = () => setIsOverflowing(content.scrollWidth > container.clientWidth + 1)
    measure()

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure)
      return () => window.removeEventListener('resize', measure)
    }

    const observer = new ResizeObserver(measure)
    observer.observe(container)
    observer.observe(content)
    return () => observer.disconnect()
  }, [text])

  return (
    <div ref={containerRef} className={clsx('overflow-marquee', className)} title={text}>
      <span className={clsx('overflow-marquee__track', isOverflowing && 'is-scrolling')}>
        <span ref={textRef} className="overflow-marquee__text">{text}</span>
        {isOverflowing && <span className="overflow-marquee__text" aria-hidden="true">{text}</span>}
      </span>
    </div>
  )
}
